import { Component, NgZone } from '@angular/core';
import { Observable } from 'rxjs';
import { Customers } from 'server/shared/collections/customers';
import { Customer } from 'server/shared/models/customer';
import { RoleEnum } from 'server/shared/models/role.enum';
import { rxNgZoneRun } from 'src/helpers/rxNgZoneRun';
import { CustomerService } from '../../services/customer.service';

@Component({
  selector: 'support',
  templateUrl: 'support.html',
  styleUrls: ['support.scss'],
})
export class SupportComponent {
  customers?: Observable<Customer[]>;
  role?: RoleEnum;
  roleTracker?: Tracker.Computation;
  roleEnum = RoleEnum;
  initialized = false;

  customer$ = this.customerService.readyDispoCustomer$;

  constructor(
    private ngZone: NgZone,
    private customerService: CustomerService,
  ) {}

  ngOnInit(): void {
    this.roleTracker = Tracker.autorun(() => {
      let role = Session.get('role');
      if (!this.initialized)
        setTimeout(() => {
          this.initialized = true;
        }, 120);
      if (this.role === undefined && role !== undefined) {
        this.ngZone.run(() => {
          this.role = role;
        });
      }
    });
    this.customers = Customers.find().pipe(rxNgZoneRun(this.ngZone));
  }

  ngOnDestroy() {
    this.roleTracker?.stop();
  }
}
